import { auth } from '../../plugins/firebase'

export default (to, from, next) => {
    const requiresAuth = to.matched.some((r) => r.meta.requiresAuth)

    if (requiresAuth && !auth.currentUser) return next('/login')
    else if (!requiresAuth && auth.currentUser) return next('/')

    next()
}